import {
  Component,
  OnInit,
  OnDestroy,
  NgZone,
  ViewChild,
  Input,
} from "@angular/core";

import { Subscription } from "rxjs";

import { ModalDirective } from "ngx-bootstrap/modal";

import {
  AuthorizationService,
  EventSubscriptionService,
  EquipmentService,
  ModelService,
  PoweredByService,
  MinesiteService,
  ClassificationService,
  Company,
  Document,
  User,
  Equipment,
  Minesite,
  Model,
  PoweredBy,
  Classification,
} from "./../../../../shared/index";

@Component({
  selector: "model-details",
  templateUrl: "./model-details.html",
  standalone: false,
})
export class ModelDetailsComponent implements OnInit, OnDestroy {
  @ViewChild("modelDetails") modal: ModalDirective;
  public model: Model = new Model();
  @Input("live") live = true;
  public equipment: Equipment = new Equipment();
  public modelEquipment: Equipment[] = [];
  public modelMinesites: Minesite[] = [];
  public modelUsers: User[] = [];
  public modelDocuments: Document[] = [];

  public classifications: Classification[] = [];

  private subscriptions: Subscription[] = [];

  constructor(
    private _ngZone: NgZone,
    private _modelService: ModelService,
    private _classificationService: ClassificationService
  ) {
    this.subscriptions.push(
      this._modelService.modelEquipmentChange.subscribe(
        (equipemnt: Equipment[]) => {
          this._ngZone.run(() => {
            this.modelEquipment = equipemnt;
          });
        }
      )
    );

    this.subscriptions.push(
      this._modelService.modelMinesitesChange.subscribe(
        (minesites: Minesite[]) => {
          this._ngZone.run(() => {
            this.modelMinesites = minesites;
          });
        }
      )
    );

    this.subscriptions.push(
      this._modelService.modelUsersChange.subscribe((users: User[]) => {
        this._ngZone.run(() => {
          this.modelUsers = users;
        });
      })
    );

    this.subscriptions.push(
      this._modelService.modelDocumentsChange.subscribe(
        (documents: Document[]) => {
          this._ngZone.run(() => {
            this.modelDocuments = documents;
          });
        }
      )
    );

    this.subscriptions.push(
      this._classificationService.classificationChange.subscribe(
        (classifications: Classification[]) => {
          this._ngZone.run(() => {
            this.classifications = classifications;
          });
        }
      )
    );

    this.subscriptions.push(
      this._modelService.showDetailsChange.subscribe((model: Model) => {
        this._ngZone.run(() => {
          // need to look
          if (this.live) {
            this.model = model;
            this._modelService.getEquipmentForModel(model.Id);
            this._modelService.getMinesitesForModel(model.Id);
            this._modelService.getUsersForModel(model.Id);
            this._modelService.getDocumentsForModel(model.Id);
          } else {
            this.model = model;
            this._modelService.GetEquipmentForModelStaged(model.Id);
            this._modelService.getMinesitesForModelStaged(model.Id);
            this._modelService.getUsersForModelStaged(model.Id);
            this._modelService.getDocumentsForModel(model.Id);
          }

          this.modal.show();
        });
      })
    );
  }

  public close() {
    this.modal.hide();
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }
}
